var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShortDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 101,
    viewBox: "0 0 137 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_18638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1247 55.6964L22.4506 50.3804L65.0582 92.9071C57.0693 100.881 43.7542 103.539 35.7653 95.5653L14.4618 74.3017L14.4526 74.2922C9.13913 68.9762 11.8021 61.009 17.1247 55.6964ZM6.47302 66.328C2.3555 62.2183 -0.0207087 56.3707 -0.0667028 50.3804C-0.109939 56.0126 1.90681 61.7705 6.47302 66.328ZM9 37.5C4.43379 42.0575 -0.109939 44.7483 -0.0667028 50.3804C-0.0207087 44.3902 4.88248 41.6097 9 37.5Z",
    fill: "url(#paint0_linear_3052_18638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7593 5.19421C43.7481 -2.77955 57.0634 -0.121353 65.0522 7.85242L22.4985 50.3241L22.4497 50.3788L17.1235 55.6952C11.801 61.0079 9.13825 68.9749 14.4517 74.2909L6.47217 66.327C2.35465 62.2173 -0.021877 56.369 -0.0678711 50.3788C-0.0217856 44.3887 2.35473 38.5411 6.47217 34.4315L14.2876 26.6307C14.3412 26.5749 14.3954 26.519 14.4507 26.4637L14.4517 26.4628L14.4556 26.4579L35.7593 5.19421Z",
    fill: "#62B5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.236 5.19422C93.2468 -2.77956 79.9317 -0.121752 71.9429 7.85202L114.55 50.3791L119.876 45.0631C125.202 39.7475 127.865 31.7737 122.539 26.4577L101.236 5.19422ZM126 59C130.566 54.4425 130.043 52.1322 130 46.5C129.954 52.4903 130.117 54.8903 126 59ZM130.528 34.4315C130 39 129.954 40.5097 130 46.5C130.043 40.8678 129.5 40 130.528 34.4315Z",
    fill: "url(#paint1_linear_3052_18638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.525 34.4316C134.642 38.5412 137.019 44.3888 137.065 50.3789C137.019 56.3692 134.642 62.2175 130.525 66.3271L122.611 74.2256C122.587 74.2501 122.564 74.2763 122.54 74.3008L101.236 95.5635C93.247 103.537 79.9317 100.879 71.9429 92.9053L114.548 50.3799L114.547 50.3789L119.874 45.0635C125.199 39.7479 127.862 31.774 122.537 26.458L130.525 34.4316Z",
    fill: "#62B5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_18638",
    x1: 68.5009,
    y1: 0.381081,
    x2: 68.5009,
    y2: 100.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1D3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3052_18638",
    x1: 68.5001,
    y1: 0.379733,
    x2: 68.5001,
    y2: 100.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1D3645"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_18638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 100,
    fill: "white",
    transform: "translate(0 0.380737)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShortDark);
export default __webpack_public_path__ + "static/media/logo-short-dark.ba59b88708763b271dbac8ece7c55931.svg";
export { ForwardRef as ReactComponent };